import { render, staticRenderFns } from "./DirectMessaging.vue?vue&type=template&id=94c6c6d2"
import script from "./DirectMessaging.vue?vue&type=script&lang=ts"
export * from "./DirectMessaging.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports